// extracted by mini-css-extract-plugin
export default {"text":"_1ELrw","mobile":"_16Obk"};